import React from "react";
import swal from "sweetalert";

export default class PopConfirm extends React.Component<any, any> {
  onDelete = () => {
    const { title = "Are you sure?", onConfirm, ...props } = this.props;

    swal({
      title,
      icon: "warning",
      closeOnClickOutside: false,
      className: "sn-m-modal",
      buttons: {
        cancel: {
          text: "No",
          value: null,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-silver",
          closeModal: true,
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "sn-btn sn-btn-sm",
          closeModal: true,
        },
      },
      dangerMode: true,
      ...props,
    }).then((willConfirm: boolean) => {
      if (willConfirm) {
        onConfirm();
      } else {
        return false;
      }
    });
  };

  render() {
    const { children } = this.props;
    return <span onClick={this.onDelete}>{children}</span>;
  }
}
